import React, { useState } from 'react';
import { Icon } from '../components/Layout';
import Footer from '../components/Footer';
import axios from 'axios';


export default function CreatePlaylist() {
  const [playlistName, setPlaylistName] = useState('');
  const [playlistDescription, setPlaylistDescription] = useState('');
  const [isPublic, setIsPublic] = useState(true);
  const [coverImage, setCoverImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCoverImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCreatePlaylist = async () => {
    if (!playlistName.trim()) {
      setError('Please enter a playlist name');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('user');
      console.log('CreatePlaylist - Token from localStorage:', token);
      
      if (!token) {
        setError('Please login to create a playlist');
        return;
      }
      
      console.log('Sending request with token:', token.substring(0, 20) + '...');
      
      const formData = new FormData();
      formData.append('name', playlistName);
      formData.append('description', playlistDescription);
      if (coverImage) {
        formData.append('image', coverImage);
      }

      const response = await axios.post(`https://api.samasong.com/sama-music/albums/create`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        setSuccess('Playlist created successfully!');
        setPlaylistName('');
        setPlaylistDescription('');
        setCoverImage(null);
        setImagePreview(null);
      } else {
        setError(response.data.message || 'Failed to create playlist');
      }
    } catch (err) {
      console.error('Create playlist error:', err);
      setError(err.response?.data?.message || 'Failed to create playlist. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>

      <div className=" mx-auto space-y-6 xs:space-y-8">
        <div className="text-center">
          <Icon.Plus className="w-12 h-12 xs:w-16 xs:h-16 text-fuchsia-500 mx-auto mb-3 xs:mb-4" />
          <h2 className="text-2xl xs:text-3xl font-bold mb-2">Create New Playlist</h2>
          <p className="text-sm xs:text-base text-slate-400">Create a playlist to organize your favorite music</p>
        </div>

        {error && (
          <div className="bg-red-500/20 border border-red-500/50 p-4 rounded-lg text-red-300 text-sm">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-500/20 border border-green-500/50 p-4 rounded-lg text-green-300 text-sm">
            {success}
          </div>
        )}

        <div className="bg-white/5 backdrop-blur-lg rounded-xl xs:rounded-2xl border border-white/10 p-4 xs:p-6 sm:p-8 space-y-4 xs:space-y-6">
          {/* Playlist Cover Image Upload */}
          <div className="flex justify-center">
            <div className="relative w-32 h-32 xs:w-40 xs:h-40 sm:w-48 sm:h-48 bg-gradient-to-br from-fuchsia-500/20 to-purple-500/20 rounded-xl xs:rounded-2xl border-2 border-dashed border-white/20 flex items-center justify-center overflow-hidden">
              {imagePreview ? (
                <img src={imagePreview} alt="Preview" className="w-full h-full object-cover" />
              ) : (
                <div className="text-center">
                  <Icon.Music className="w-8 h-8 xs:w-10 xs:h-10 sm:w-12 sm:h-12 text-slate-400 mx-auto mb-1 xs:mb-2" />
                  <p className="text-xs xs:text-sm text-slate-400">Playlist Cover</p>
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
          </div>

          {/* Playlist Name */}
          <div>
            <label className="block text-xs xs:text-sm font-medium text-slate-300 mb-1 xs:mb-2">
              Playlist Name *
            </label>
            <input
              type="text"
              value={playlistName}
              onChange={(e) => setPlaylistName(e.target.value)}
              placeholder="Enter playlist name"
              className="w-full px-3 xs:px-4 py-2.5 xs:py-3 bg-white/5 border border-white/10 rounded-lg xs:rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent text-sm xs:text-base"
            />
          </div>

          {/* Playlist Description */}
          <div>
            <label className="block text-xs xs:text-sm font-medium text-slate-300 mb-1 xs:mb-2">
              Description
            </label>
            <textarea
              value={playlistDescription}
              onChange={(e) => setPlaylistDescription(e.target.value)}
              placeholder="Describe your playlist (optional)"
              rows={3}
              className="w-full px-3 xs:px-4 py-2.5 xs:py-3 bg-white/5 border border-white/10 rounded-lg xs:rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent resize-none text-sm xs:text-base"
            />
          </div>

          {/* Privacy Setting */}
          <div className="flex flex-col xs:flex-row xs:items-center justify-between gap-2 xs:gap-0">
            <div>
              <p className="text-xs xs:text-sm font-medium text-slate-300">Make playlist public</p>
              <p className="text-xs text-slate-400">Anyone can see this playlist</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
                className="sr-only peer"
              />
              <div className="w-14 h-7 bg-slate-700 rounded-full peer peer-checked:bg-fuchsia-600 transition-all">
                <div className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full transition-all ${isPublic ? 'translate-x-7' : ''}`}></div>
              </div>
            </label>
          </div>

          {/* Create Button */}
          <button
            onClick={handleCreatePlaylist}
            disabled={isLoading}
            className="w-full bg-fuchsia-600 hover:bg-fuchsia-700 disabled:bg-slate-600 disabled:cursor-not-allowed text-white font-semibold py-2.5 xs:py-3 px-4 xs:px-6 rounded-lg xs:rounded-xl transition-colors text-sm xs:text-base flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Creating...
              </>
            ) : (
              'Create Playlist'
            )}
          </button>
        </div>

        {/* Tips */}
        <div className="bg-white/5 backdrop-blur-lg rounded-xl xs:rounded-2xl border border-white/10 p-4 xs:p-6">
          <h3 className="text-base xs:text-lg font-semibold mb-3 xs:mb-4">Tips for creating playlists</h3>
          <ul className="space-y-2 xs:space-y-3 text-xs xs:text-sm text-slate-400">
            <li>• Choose a descriptive name that reflects the mood or theme</li>
            <li>• Add a description to help others understand your playlist</li>
            <li>• Public playlists can be discovered by other users</li>
            <li>• You can always edit playlist details later</li>
          </ul>
        </div>
      </div>

    <Footer/>
    </>
  );
}